import { helmetJsonLdProp } from 'react-schemaorg';
import { Product } from 'schema-dts';
import { IAverageRating, IImage } from '@lialo/core/lib/models';
import { TFunction } from 'i18next';
import { chooseTourImageLink } from '@lialo/core/lib/utils/helper/image-link';

export function createProductSchema(
  t: TFunction,
  tourCode: string,
  title: string | undefined,
  averageRating: IAverageRating | undefined,
  description: string | undefined,
  images: IImage[] | undefined
) {
  const img = images?.[0] ? chooseTourImageLink(images[0].url, 1024) : undefined;

  return [
    helmetJsonLdProp<Product>({
      '@context': 'https://schema.org',
      '@type': 'Product' as const,
      name: t('tour_detail.meta.title', { title }),
      aggregateRating:
        averageRating && averageRating.ratingCount > 0
          ? {
            '@type': 'AggregateRating' as const,
            ratingValue: `${averageRating.averageRating ?? '0'}`,
            ratingCount: averageRating.ratingCount,
            bestRating: '5',
            worstRating: '1',
          }
          : undefined,
      image: img,
      description: description,
    }),
  ];
}
